import { Button, Grid } from "@mui/material";

const ModalFooterSaveCancel = (props: any) => {

	return (
		<Grid container className="modal-footer">
			<Grid item xs={3}>
				<Button fullWidth variant="contained" onClick={props.Save} disabled={!props.ShowSave} className={`${props.ShowSave ? 'bg-success' : 'bg-disabled'} text-white btn-list`}>Save</Button>
			</Grid>
			<Grid item xs={1}></Grid>
			<Grid item xs={8}>
				<Button fullWidth variant="outlined" onClick={props.Close} className="border-success text-success btn-list">Cancel</Button>
			</Grid>
		</Grid>
	);
}

export default ModalFooterSaveCancel;